import { lazy } from 'react'

// project imports
import MainLayout from 'layout/MainLayout'
import Loadable from 'ui-component/Loadable'
import ErrorElement from 'routes/ErrorElement'
import PlaceholderPage from 'views/PlaceholderPage'

// dashboard routing
const AIGeneration = Loadable(lazy(() => import('views/AIGeneration')))
const AssetPage = Loadable(lazy(() => import('views/Asset')))
const Bookings = Loadable(lazy(() => import('views/Bookings')))
const BookingsOverview = Loadable(lazy(() => import('views/BookingsOverview')))
const Dashboard = Loadable(lazy(() => import('views/Dashboard')))
const Orders = Loadable(lazy(() => import('views/Orders')))
const Profile = Loadable(lazy(() => import('views/Profile')))
const ProjectPage = Loadable(lazy(() => import('views/Project')))
const UploadPage = Loadable(lazy(() => import('views/Upload')))

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  errorElement: <ErrorElement />,
  children: [
    {
      path: '/',
      element: <Dashboard />,
      errorElement: <ErrorElement />,
    },
    {
      path: 'bookings-overview',
      element: <BookingsOverview />,
      children: [
        {
          path: '',
          element: <Orders />,
        },
      ],
    },
    {
      path: 'profile',
      element: <Profile />,
    },
    {
      path: 'project/:id',
      element: <ProjectPage />,
    },
    {
      path: 'project/:id/asset/:assetId',
      element: <AssetPage />,
    },
    {
      path: 'project/:id/asset/:assetId/ai-house',
      element: <AIGeneration />,
    },
    {
      path: 'project/:id/bookings',
      element: <Bookings />,
    },
    {
      path: 'project/:id/task/:taskId/files',
      element: <UploadPage />,
    },
    {
      path: 'forbidden',
      element: <PlaceholderPage message="You do not have access to this page." />,
    },
  ],
}

export default MainRoutes
